import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { MercuryService } from '../service/mercury.service';
import { StoryBlokService } from '../service/storyblok.service';
import { ThemeService } from '../service/theme.service';
import { CustomiseWizardResolverData, PersonaliserPage } from '../content-source/customise-wizard/customise-wizard.types';
import { ResolverErrorService } from './resolver-error.service';

export const CustomiseWizardResolver: ResolveFn<CustomiseWizardResolverData> = async (
  route: ActivatedRouteSnapshot,
) => {
  const storyblokService = inject(StoryBlokService);
  const mercuryService = inject(MercuryService);
  const themeService = inject(ThemeService);
  const resolverError = inject(ResolverErrorService);

  const handle = route.params['handle'];
  const fail = (err: unknown): never => {
    resolverError.handle(err);
    throw new Error('Not Found');
  };

  let page: PersonaliserPage;
  try {
    const result = await storyblokService.getStory(
      'personaliser-product/' + handle,
      {
        resolve_relations: ['personaliser-entry.config'],
      },
    );
    themeService.viewPage(result);
    const title = result?.story?.content?.metatags?.title || result.story.name;
    const description = result?.story?.content?.metatags?.description || '';
    page = { ...result, seo: { title, description } } as unknown as PersonaliserPage;
  } catch (err) {
    return fail(err);
  }

  const [product, personalisation] = await Promise.all([
    lastValueFrom(mercuryService.getProductByHandle(handle)).catch(fail),
    lastValueFrom(mercuryService.getProductByHandle('personalisation')).catch(fail),
  ]);

  return { page, seo: page.seo, product, personalisation };
};
